angular.module('zc.zenclerkS')

  .component('zcsDashboardWidgetTagSetup', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetTagSetupController
  });

zcsDashboardWidgetTagSetupController.$inject = [];
function zcsDashboardWidgetTagSetupController() {
  const vm = this;

  vm.$onInit = () => {
    vm.project = vm.dashboard.project;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.component.js